import axios from 'axios'
import {createBrowserHistory} from 'history';
import {useLocation} from "react-router-dom";
import {BASE_URL} from "../constants/urls";
import {useAuthStore} from "../store/AuthStore";
import Cookies from 'js-cookie';

const history = createBrowserHistory();

const apiRequest =  axios.create({
    baseURL: BASE_URL,
    headers: {},
    params: {}
})

apiRequest.interceptors.request.use((config) => {
    const companyToken = Cookies.get('token');
    config.headers['Authorization'] = `Bearer ${companyToken}`;
    return config;
});

apiRequest.interceptors.response.use((response) => {
    return response;
},
async (err) => {
    let unAuthError = true;

    const navigateToLogin = () => {
        history.push('/login');
        Cookies.remove('token');
    };

    if (err.message === 'Network Error') {
        // navigateToLogin();
        console.log('Network Error');
    }

    if (err?.response?.status === 401) {
        useAuthStore.setState({authorized: false});
        navigateToLogin();
        unAuthError = true;
    }
    if (unAuthError && err?.response?.status === 401) {
        navigateToLogin();
        useAuthStore.setState({authorized: false});
    } else if (err?.response?.status !== 401) {
        console.log('Network error 2');
    }
    return Promise.reject(err);
},
);

export default apiRequest
